/* tslint:disable */
/* eslint-disable */
export enum SessionStatus {
  Ready = 'Ready',
  Running = 'Running',
  Flushed = 'Flushed',
  Error = 'Error'
}
